import { z } from 'zod';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';
import { BaseIntegration } from 'libs/end-to-end/src/types/databases/integrations/base-integration';

export const GreenhouseIntegration = BaseIntegration.extend({
  integrationType: z.literal('Greenhouse'),
  apiKeySecretReference: SecretReference.optional(),
});

export type GreenhouseIntegration = z.infer<typeof GreenhouseIntegration>;
